module.exports = __webpack_public_path__ + "static/media/nice-to-meet.31ca18a0.gif";